export default __webpack_public_path__ + "rainbow.2b6f8feb.svg";